module.exports = __webpack_public_path__ + "img/Vector_50_9697.6969a5b9.png";